import '../../App.css';
import React from 'react';
import Footer from '../Footer';
import ExamplesHeroSection from '../ExamplesHeroSection'
import Card from '../Card';
import WebsiteExamples from '../WebsiteExamples';

function Examples() {
    return (
        <>
            <title>Examples | SiteHart
            </title>
            <ExamplesHeroSection></ExamplesHeroSection>
            <WebsiteExamples></WebsiteExamples>

        </>
    )
}

export default Examples;